import * as actionType from '../../actionTypes'

export const setExchangeIntoTiff = payload => ({
  type: actionType.setExchangeIntoTiffType,
  payload
});

export const setInputValues = payload => ({
  type: actionType.setInputValuesType,
  payload
});

export const valueExchangeFromTiff = payload => ({
  type: actionType.valueExchangeFromTiffType,
  payload
});

export const getTiffData = payload => ({
  type: actionType.getTiffDataType,
  payload
});

export const getExpectedExchangeDate = payload => ({
  type: actionType.getExpectedExchangeDateType,
  payload
});


export const setStepOne = payload => ({
  type: actionType.setStepOneType,
  payload
});

export const setStepTwo = payload => ({
  type: actionType.setStepTwoType,
  payload
});

export const selectTiffOption = payload => ({
  type: actionType.selectTiffOptionType,
  payload
});

export const submitTiffForm = payload => ({
  type: actionType.submitTiffFormType,
  payload
});

export const getTiffFormInfo = payload => ({
  type: actionType.getTiffFormInfoType,
  payload
});

export const getTiffDisclaimer = payload => ({
  type: actionType.getTiffDisclaimerType,
  payload
});

export const fetchPoolData = payload => ({
  type: actionType.fetchPoolDataType,
  payload,
});

export const fetchUnderlyingFunds = payload => ({
  type: actionType.fetchUnderlyingFundsType,
  payload,
});

export const setPoolModalFalse = payload => ({
  type: actionType.setPoolModalFalseType,
  payload,
});

export const resetFlow = payload => ({
  type: actionType.resetFlowType,
});

export const submitUpdateTiff = payload => ({
  type: actionType.submitUpdateTiffType,
  payload
});

export const updateFromAmount = payload => ({
  type: actionType.updateFromAmountType,
  payload
});

export const getAllPools = payload => ({
  type: actionType.getAllPoolsType,
  payload
});

export const getPoolsInfo = payload => ({
  type: actionType.getPoolsInfoType,
  payload
});

export const resetInitialFlow = payload => ({
  type: actionType.resetInitialFlowType,
});

export const editMode = payload => ({
  type: actionType.editModeType,
  payload,
});

export const fetchAllPoolDataFrom = payload => ({
  type: actionType.fetchAllPoolDataFromType,
  payload,
});

export const fetchAccountDataTiff = payload => ({
  type: actionType.fetchAccountDataTiffType,
  payload,
});

export const submitFormData = payload => ({
  type: actionType.submitFormDataType,
  payload,
});

export const disableFrom = payload => ({
  type: actionType.disableFromType,
  payload,
});

export const valueInFormChange = payload => ({
  type: actionType.valueInFormChangeType,
  payload,
});

export const formDrupalContent = payload => ({
  type: actionType.formDrupalContentType,
  payload,
});

export const submitDataSuccess = payload => ({
  type: actionType.submitDataSuccessType,
  payload,
});

export const submitDataError = payload => ({
  type: actionType.submitDataErrorType,
  payload,
});